import { getHeadersWithTokens } from 'api/ApiHelpers';
import ClientInstance from 'api/ClientInstance';

interface IstaffEndpoints {
  getStaff: any,
  postStaff: any,
  showStaffDetail: any,
  searchStaff: any,
  deleteStaff: any;
  updateAdmins: any;
  putMember: (body: any, memberId: number) => Promise<any>;
  checkEmail: (email: String) => Promise<any>;
}

const staffEndpoints: IstaffEndpoints = {
  getStaff: (body:any) => ClientInstance.get('/organizations/shared/staff', {
    params: body,
    ...getHeadersWithTokens()
  }),
  searchStaff: (page:number, query: string) => ClientInstance.get(`/organizations/shared/staff?page=${page}&per_page=15&q=${query}`, getHeadersWithTokens(true)),
  postStaff: (body:any) => ClientInstance.post('/organizations/shared/staff', body, getHeadersWithTokens(true)),
  showStaffDetail: (id:number) => ClientInstance.get(`/organizations/shared/staff/${id}`, getHeadersWithTokens(true)),
  deleteStaff: (id:number) => ClientInstance.delete(`organizations/shared/staff/${id}`, getHeadersWithTokens(true)),
  putMember: (body: any, memberId: number) => ClientInstance.put(`/organizations/shared/staff/${memberId}`, body),
  updateAdmins: ({ body, centerId, directorId }: any) => ClientInstance.put(`/organizations/shared/centers/${centerId}/directors/${directorId}`, body, getHeadersWithTokens(true)),
  checkEmail: (email: String) => ClientInstance.get('users/email-availability', { params: { encode_email: email } }),
};

export default staffEndpoints;
